export const NAVIGATION_TYPES = [
  'navigate',
  'reload',
  'back-forward',
  'back-forward-cache',
  'prerender',
  'restore',
] as const;

export type NavigationType = (typeof NAVIGATION_TYPES)[number];

export const CONNECTION_TYPES = ['slow-2g', '2g', '3g', '4g'] as const;

export type ConnectionType = (typeof CONNECTION_TYPES)[number];

export interface PageLoadMetrics {
  ttfb: number | null;
  fcp: number | null;
  lcp: number | null;
  inp: number | null;
  cls: number | null;
  navigationType: NavigationType | null;
}

/** Ids shared with the tracking events, so a report can be joined with the visitor's page views. */
export interface TrackingIds {
  sessionUuid: string | null;
  userUuid: string | null;
}

interface ReportedPage extends TrackingIds {
  route: string;
  path: string;
}

interface PageLoadReport extends ReportedPage, PageLoadMetrics {
  kind: 'pageLoad';
  connectionType: ConnectionType | null;
}

interface NavigationReport extends ReportedPage {
  kind: 'navigation';
  durationMs: number;
}

export type WebVitalsReport = PageLoadReport | NavigationReport;

/** One row of the web vitals table in the warehouse: every key is always present, null when not applicable. */
export interface WebVitalsRecord {
  event_id: string;
  timestamp: string;
  app: 'public';
  kind: WebVitalsReport['kind'];
  session_uuid: string | null;
  user_uuid: string | null;
  route: string;
  path: string;
  ttfb: number | null;
  fcp: number | null;
  lcp: number | null;
  inp: number | null;
  cls: number | null;
  navigation_type: NavigationType | null;
  connection_type: ConnectionType | null;
  duration_ms: number | null;
  device: 'mobile' | 'desktop';
  country: string | null;
}
